import React from 'react';
import './style.scss';
import '../../style.scss';
import { Modal } from 'antd';

const ModalNoti = ({ 
  visible,
  title = 'Thông báo',
  onClick = () => {},
  onCancel = () => {},
  message,
  closable = true,
  btnText = '',
  ...rest
}) => {
  return (
    <Modal
      className="qr-code__modal-custom"
      title={null}
      footer={null}
      open={visible}
      onCancel={onCancel}
      closable={closable}
      {...rest}
    >
    <div className="qr-code__modal-modal-noti">
      <div className="modal-noti-title">{title}</div>
      <div className="modal-noti-txt">
        {message}
      </div>
      {btnText && <button className="qr-code__btn-custom modal-noti-btn" onClick={onClick}>{btnText}</button>}
    </div>
  </Modal>
  );
}

export default React.memo(ModalNoti);
